import React from "react"

import globalStyles from "../../../../App.module.scss";
import scan from './images/scan.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function SecretsScanner() {

    let data = `import re
import sys
from pathlib import Path

PATTERNS = {
    "AWS Access Key": r"AKIA[0-9A-Z]{16}",
    "Generic API Key": r"(?i)(api[_-]?key|secret|token|password)\\s*[:=]\\s*['\\"][A-Za-z0-9_\\-]{16,}['\\"]",
    "Private Key": r"-----BEGIN (RSA|EC|DSA|OPENSSH|PGP) PRIVATE KEY-----",
    "Slack Token": r"xox[baprs]-[0-9A-Za-z-]{10,}",
}

SKIP_DIRS = {".git", "node_modules", "venv", "__pycache__", "build", "dist"}
TEXT_EXTENSIONS = {".py", ".js", ".jsx", ".ts", ".tsx", ".env", ".yml", ".yaml", ".json", ".txt", ".sh", ".md"}


def scan_file(path):
    findings = []
    try:
        text = path.read_text(errors="ignore")
    except OSError:
        return findings
    for line_number, line in enumerate(text.splitlines(), start=1):
        for label, pattern in PATTERNS.items():
            if re.search(pattern, line):
                findings.append((line_number, label, line.strip()[:80]))
    return findings


def scan_directory(root):
    all_findings = []
    for path in Path(root).rglob("*"):
        if not path.is_file():
            continue
        if any(part in SKIP_DIRS for part in path.parts):
            continue
        if path.suffix not in TEXT_EXTENSIONS:
            continue
        for line_number, label, snippet in scan_file(path):
            all_findings.append((path, line_number, label, snippet))
    return all_findings


def main():
    root = sys.argv[1] if len(sys.argv) > 1 else "."
    findings = scan_directory(root)

    if not findings:
        print("No potential secrets found.")
        return

    for path, line_number, label, snippet in findings:
        print(f"{path}:{line_number}  [{label}]  {snippet}")
    print(f"\\n{len(findings)} potential secret(s) found.")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Secrets scanner</h1>
            <p>Walks a codebase looking for text that resembles a hardcoded credential — AWS access keys, private
                key headers, Slack tokens, and generic <code>api_key = "..."</code>-style assignments. A quick
                pre-commit safety net; it isn't a substitute for a real secret-scanning service, but it catches the
                obvious accidents.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={scan} alt={""}/>
            </div>
        </div>
    )
}
